// Clients
export const ALL_CLIENTS = 'ALL_CLIENTS';
export const SITES_PER_CLIENT = 'SITES_PER_CLIENT';
export const CLIENT_BY_UUID = 'CLIENT_BY_UUID';
export const AVAILABLE_CLIENTS_LIST = 'AVAILABLE_CLIENTS_LIST';

// Content
export const CONTENT_BY_UUID = 'CONTENT_BY_UUID';

// Follows
export const FOLLOW_DATA_BY_UUID = 'FOLLOW_DATA_BY_UUID';

// Language
export const GET_TRANSLATION = 'GET_TRANSLATION';
export const GET_CURRENT_LANGUAGE = 'GET_CURRENT_LANGUAGE';

// Navigation
export const ACTIVE_WORKSPACES = 'ACTIVE_WORKSPACES';
export const ACTIVE_QUICK_SEARCHES = 'ACTIVE_QUICK_SEARCHES';

// Pages
export const PAGE_BY_UUID = 'PAGE_BY_UUID';

// Queues
export const CURRENT_QUEUE_UUID = 'CURRENT_QUEUE_UUID';
export const CURRENT_QUEUE = 'CURRENT_QUEUE';
export const QUEUE_BY_UUID = 'QUEUE_BY_UUID';
export const QUEUE_BY_FILTER = 'QUEUE_BY_FILTER';
export const QUEUE_TAG_LIST = 'QUEUE_TAG_LIST';
export const QUEUE_FILTER_TAG_LIST = 'QUEUE_FILTER_TAG_LIST';

// Quick Searches
export const QUICK_SEARCH_BY_HASH = 'QUICK_SEARCH_BY_HASH';
export const ALL_QUICK_SEARCHES = 'ALL_QUICK_SEARCHES';

// Routes
export const CURRENT_ROUTE = 'CURRENT_ROUTE';
export const CURRENT_ROUTE_NAME = 'CURRENT_ROUTE_NAME';

// Searches
export const CURRENT_SEARCH_UUID = 'CURRENT_SEARCH_UUID';
export const CURRENT_SEARCH = 'CURRENT_SEARCH';
export const SEARCH_BY_UUID = 'SEARCH_BY_UUID';
export const SEARCH_TAG_LIST = 'SEARCH_TAG_LIST';
export const SEARCH_FILTER_TAG_LIST = 'SEARCH_FILTER_TAG_LIST';

// Settings
export const SITE_SETTINGS = 'SITE_SETTINGS';

// Sites
export const ALL_SITES = 'ALL_SITES';
export const SITE_BY_UUID = 'SITE_BY_UUID';
export const ACTIVE_SITE_UUID = 'ACTIVE_SITE_UUID';

// Time
export const CURRENT_TIME = 'CURRENT_TIME';
export const PREVIOUS_TIME = 'PREVIOUS_TIME';
export const IS_INACTIVE = 'IS_INACTIVE';
export const LAST_ACTIVE = 'LAST_ACTIVE';
export const GET_TIME = 'GET_TIME';
export const GET_EVENT_HISTORY = 'GET_EVENT_HISTORY';
export const GET_CURRENT_TIME_FIELD = 'GET_CURRENT_TIME_FIELD';

// Users
export const USER_BY_UUID = 'USER_BY_UUID';
export const CURRENT_USER_UUID = 'CURRENT_USER_UUID';
export const CURRENT_USER_IS_GLOBAL_ADMIN = 'CURRENT_USER_IS_GLOBAL_ADMIN';
export const USER_COMMENTS = 'USER_COMMENTS';
export const TOTAL_USER_COMMENTS_BY_UUID = 'TOTAL_USER_COMMENTS_BY_UUID';
export const USER_BY_ORIGIN = 'USER_BY_ORIGIN';

// Workspaces
export const CURRENT_WORKSPACE_UUID = 'CURRENT_WORKSPACE_UUID';
export const CURRENT_WORKSPACE = 'CURRENT_WORKSPACE';
export const WORKSPACE_BY_UUID = 'WORKSPACE_BY_UUID';
export const ALL_WORKSPACES = 'ALL_WORKSPACES';
export const IS_ACTIVE_WORKSPACE_OWNED_BY_USER = 'IS_ACTIVE_WORKSPACE_OWNED_BY_USER';
export const IS_WORKSPACE_OWNED_BY_USER = 'IS_WORKSPACE_OWNED_BY_USER';
export const DOES_WORKSPACE_EXIST = 'DOES_WORKSPACE_EXIST';

// Version
export const CONSOLE_VERSION = 'CONSOLE_VERSION';
export const IS_OUT_OF_DATE = 'IS_OUT_OF_DATE';
